// Update Profilename
export const profileNameUpdate = state => state.profileNameUpdate;

// Update Email
export const emailUpdate = state => state.emailUpdate;

// Update Birthdate
export const birthdateUpdate = state => state.birthdateUpdate;
